export default "__VITE_ASSET__5803c273__";